import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TableCell, type Props as TableCellProps } from '../../../common/ui/table-cell';
import messages from './messages';

export type PropsBlankIssue = {
	isSelected: boolean;
	numColumns: number;
	hasFixedTableLayout: boolean;
	cellBorder?: TableCellProps['border'];
};

const BlankIssueRow = ({
	numColumns,
	isSelected,
	hasFixedTableLayout,
	cellBorder,
}: PropsBlankIssue) => {
	const { formatMessage } = useIntl();

	// Extra column added to account for the blank spacer column added to the table
	return (
		<TableCell
			colSpan={numColumns + (ff('nin-resizable-columns_8z4eo') && hasFixedTableLayout ? 1 : 0)}
			border={cellBorder}
		>
			<Text isSelected={isSelected}>{formatMessage(messages.blankRowText)}</Text>
			<FireUiAnalytics action="viewed" actionSubject="blankIssue" />
		</TableCell>
	);
};

export default BlankIssueRow;

const textColorActiveState = token('color.text.selected', colors.N400);
const textColor = token('color.text', colors.N200);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Text = styled.div<{ isSelected: boolean }>({
	color: ({ isSelected }) => (isSelected ? textColorActiveState : textColor),
	paddingLeft: token('space.050', '4px'),
	cursor: 'default',
});
